<template>
  <div class="decalare-item">
    <div>
      <div class="img-left"
           :class="{last:isLast}">
        <img :src="require('@/assets/educationAffairs/declare-dot.png')" />
      </div>
      <h3 class="class-name van-ellipsis"
          v-cloak>{{itemName}}</h3>
      <p class="enclosure"
         v-cloak>
        附件：
        <span v-if="fileState === '无'">无</span>
        <i v-if="fileState === '有'"
           @click="downLoad"
           class="iconfont">&#xe618;</i>
      </p>
    </div>
    <!-- 1待审批 2已通过 3已拒绝  -->
    <div class="status"
         v-bind:class="{wait:deState ===1, pass:deState ===2, refuse:deState ===3}"
         v-cloak>
      {{deStateName}}
    </div>
    <div class="bottom van-hairline--top"
         @click="itemClick">{{detailType}}
      <i v-show="detailType === '审批'"
         class="iconfont">&#xe60c;</i>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isLast: {
      type: Boolean,
      default: false
    },
    itemName: {
      type: String,
      default: ''
    },
    detailType: {
      type: String,
      default: ''
    },
    fileState: {
      type: String,
      default: ''
    },
    deState: {
      type: Number,
      default: 1
    },
    deStateName: {
      type: String,
      default: ''
    }
  },
  name: "DeclareListItem",
  data () {
    return {};
  },
  methods: {
    itemClick () {
      this.$emit('itemClickHandler')
    },
    downLoad () {
      this.$emit('downLoadHandler')
    },
  }
};
</script>
<style lang="less" scoped>
.decalare-item {
  margin-bottom: 20px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(211, 211, 211, 0.5);
  border-radius: 8px;
  padding: 25px 25px 25px 40px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  div:first-child {
    width: 70%;
    .class-name {
      font-size: 28px;
      font-weight: bold;
      color: #333333;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 30px;
      position: relative;
    }
    .enclosure {
      font-size: 26px;
      color: #999;
    }
    .img-left {
      width: 26px;
      height: 26px;
      position: absolute;
      left: 25px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .img-left::after {
      content: "";
      width: 2px;
      height: 200px;
      position: absolute;
      top: 30px;
      left: 12px;
      background: #d9e9ff;
    }
    .img-left.last::after {
      display: none;
    }
  }
  .status {
    width: 25%;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bottom {
    width: 100%;
    padding: 20px 40px 0 0;
    text-align: right;
    color: #ff9900;
    margin-top: 10px;
    i {
      font-size: 12px;
      color: #ff9900;
    }
  }
  .wait {
    color: #4196ff;
  }
  .pass {
    color: #19bea8;
  }
  .refuse {
    color: #ff7b69;
  }
}
</style>